import { AppBar, Box, Tab, Tabs } from '@mui/material'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

const stripSlash = (s) => s.replace(/\/+$/, '')
export const UserReportIndex = () => {
    const location = useLocation()
    const allTabs = [
        {
            label: `Total Registered Users`,
            value: `/revenue-reports/user-report/Total_Registered_Users`,
        },
        {
            label: `Active Inactive Users`,
            value: `/revenue-reports/user-report/Active_Inactive_Users`,
        },
        {
            label: `User Growth Trends`,
            value: `/revenue-reports/user-report/User_Growth_Trends`,
        },
        {
            label: `User Demographics`,
            value: `/revenue-reports/user-report/User_Demographics`,
        },
        {
            label: `Top Engaged Users`,
            value: `/revenue-reports/user-report/Top_Engaged_Users`,
        },
    ]

    const pathname = stripSlash(location.pathname) || '/revenue-reports/user-report/Total_Registered_Users'
    const subTabValue =
        allTabs.find((tab) => pathname === stripSlash(tab.value) || pathname.startsWith(stripSlash(tab.value) + '/'))?.value ??
        '/revenue-reports/user-report/Total_Registered_Users'
    return (
        <>
            <AppBar position="static" className="border-bottom" sx={{ boxShadow: 'none', background: 'transparent' }}>
                <Box>
                    <Tabs variant="scrollable" scrollButtons="auto" value={subTabValue}>
                        {allTabs.map((item, i) => (
                            <Tab key={i} style={{ textTransform: 'capitalize' }} label={item.label} value={item.value} component={NavLink} to={item.value} />
                        ))}
                    </Tabs>
                </Box>
            </AppBar>
            <div className="p-0 flex-fill mt-3 custom_scroll">
                <Outlet />
            </div>
        </>
    )
}
